<template>
	<transition :name="transitionDirection" mode="out-in">
		<div v-if="shouldShowFirstCalendar" key="stage-1">
			<h3>Pick your promotion's start date</h3>
			<v-date-picker
				class="calendar"
				:min-date="firstCalendarMin"
				:max-date="firstCalendarMax"
				:is-inline="true"
				:theme-styles='themeStyles'
				:tint-color="tintColor"
				v-model="selectedDate"
				@input="showSecondCalendar">
			</v-date-picker>
		</div>
		<div v-else key="stage-2">
			<h3><button @click="returnToFirstCalendar" class="button backward inline"></button>Pick your "No Later Than" date</h3>
			<v-date-picker
				class="calendar"
				:min-date="earliestSecondDate"
				:max-date="secondCalendarMax"
				:is-inline="true"
				:theme-styles='themeStyles'
				:tint-color="tintColor"
				v-model="selectedDateTwo"
				@input="inputDates">
			</v-date-picker>
			<p v-if="selectedDate">Start date: <strong>{{selectedDate | longDate}}</strong>. The "no later than" date is the last date your promotion could appear. Promotion does not run continuously between start date and this date but will take place between these dates.</p>
		</div>
	</transition>
</template>

<script>
	import Vue          from 'vue';
	import VCalendar    from 'v-calendar';
	import 'v-calendar/lib/v-calendar.min.css';

	Vue.use(VCalendar, {
		firstDayOfWeek: 2 // Monday
	});

	export default {
		data: () => {
			return {
				tintColor: '#FF2C73',
				transitionDirection : '', // No transition-in when component is first rendered
				stage               : 1,
				selectedDate        : null,
				selectedDateTwo     : null,
				today               : new Date(),
				themeStyles         : {
					wrapper : {
						fontSize     : '2rem',
						color        : 'white',
						borderRadius : '5px',
						marginBottom : '2rem'
					},
					header : {
						'textTransform' : 'uppercase'
					},
					// Day names i.e. "M T W T F S S"
					weekdays: {
						fontWeight : '600'
					}
				}
			}
		},
		computed: {
			earliestSecondDate () {
				let earliestDate = new Date();

				if(this.selectedDate === null) {
					return earliestDate
				}

				// Convert number of days into milliseconds
				let timeToAdd = (this.minimumBetweenStarts * 24 * 60 * 60) * 1000;

				let timezoneOffset = earliestDate.getTimezoneOffset()

				// Nullify timezone discrepancies causing the dates to be set to
				// 23:00 on the date before, for example.
				if(timezoneOffset < 0) {
					timeToAdd += Math.abs(timezoneOffset) * 60 * 1000;
				} else if (timezoneOffset > 0) {
					timeToAdd -= Math.abs(timezoneOffset) * 60 * 1000;
				}

				earliestDate.setTime(this.selectedDate.getTime() + timeToAdd);
				return earliestDate
			},

			shouldShowFirstCalendar() {
				// Allow starting with the second calendar visible if the
				// application state has already provided a value for it
				return this.stage === 1 && this.selectedDateTwo === null
			}
		},
		props: ['firstCalendarMin', 'firstCalendarMax', 'secondCalendarMax', 'minimumBetweenStarts', 'firstDate', 'secondDate'],
		methods: {
			showSecondCalendar () {
				// XK: Added slightly arbitrary timeout here so user sees the value she selected before cal1 vanishes
				setTimeout(() => {
					this.transitionDirection = 'slide-left';
					this.stage = 2;
				}, 500);
			},
			returnToFirstCalendar () {
				this.transitionDirection = 'slide-right';
				this.stage = 1;
				this.$emit('back');
			},
			inputDates () {
				this.$emit('input', [this.selectedDate, this.selectedDateTwo]);
			}
		},
		watch: {
			selectedDate () {
				// Reset the second date as it may now contain an invalid value
				this.selectedDateTwo = null;
			},

			firstDate () {
				this.selectedDate = this.firstDate;
			},

			secondDate () {
				this.selectedDateTwo = this.secondDate;
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '../../assets/scss/var';

	button.back {
		height : 30px;
		width  : 30px;
	}

	$duration : .4s;

	.slide-left-enter-active  { animation: slideLeftEnter  $duration ease-out; }
	.slide-right-enter-active { animation: slideRightEnter $duration ease-out; }
	.slide-left-leave-active  { animation: slideLeftLeave  $duration; }
	.slide-right-leave-active { animation: slideRightLeave $duration; }

	h3 {
		display         : flex;
		justify-content : center;

		.backward {
			border  : none;
			cursor  : pointer;
			padding : 0;
		}
	}


	@keyframes slideLeftEnter {
		0%   { transform: translateX(50%); opacity: 0; }
		100% { transform: translateX(0);   opacity: 1; }
	}

	@keyframes slideLeftLeave {
		0%   { transform: translateX(0);    opacity: 1; }
		100% { transform: translateX(-50%); opacity: 0; }
	}

	@keyframes slideRightEnter {
		0%   { transform: translateX(-50%); opacity: 0; }
		100% { transform: translateX(0);    opacity: 1; }
	}

	@keyframes slideRightLeave {
		0%   { transform: translateX(0);   opacity: 1; }
		100% { transform: translateX(50%); opacity: 0; }
	}

</style>
